var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomFieldTextIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 14,
    viewBox: "0 0 45 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161078",
    "data-name": "Group 161078",
    transform: "translate(-2640 -312)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Text",
    transform: "translate(2660 323)",
    fill: "#0d0d0d",
    fontSize: 12,
    fontFamily: "Silka-Regular, Silka"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Text")), /*#__PURE__*/React.createElement("g", {
    id: "text-align-left-svgrepo-com",
    transform: "translate(2638 309.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83141",
    "data-name": "Path 83141",
    d: "M2.6,5a.6.6,0,0,0,0,1.206H13.454a.6.6,0,0,0,0-1.206Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83142",
    "data-name": "Path 83142",
    d: "M2.6,13a.6.6,0,1,0,0,1.206H13.454a.6.6,0,1,0,0-1.206Z",
    transform: "translate(0 -3.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83143",
    "data-name": "Path 83143",
    d: "M2,9.6A.6.6,0,0,1,2.6,9H9.837a.6.6,0,1,1,0,1.206H2.6A.6.6,0,0,1,2,9.6Z",
    transform: "translate(0 -1.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83144",
    "data-name": "Path 83144",
    d: "M2.6,17a.6.6,0,1,0,0,1.206H9.837a.6.6,0,1,0,0-1.206Z",
    transform: "translate(0 -4.766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFieldTextIcon);
export default __webpack_public_path__ + "static/media/custom-field-text-icon.20a33f9a2cca70cffefd90b77ae7f18f.svg";
export { ForwardRef as ReactComponent };